export default "__VITE_ASSET__DYrxepT5__"